import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledImg = styled.img`
  width: 100%;
`;

function ImgViewer({ url }) {
  return <StyledImg src={url} alt="Перегляд файлу" loading="lazy" />;
}

ImgViewer.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ImgViewer;
